import React, { Component } from "react";
import "react-notifications-component/dist/theme.css";
import soundFile from "../../assets/maybe-one-day.mp3";
import waiting_sound from "../../assets/patientWaiting.wav";
import approved_sound from "../../assets/approved.mp3";
import rejected_sound from "../../assets/rejected.wav";
import editing_sound from "../../assets/editing.wav";
import pending_sound from "../../assets/review.wav";

import message_sound from "../../assets/message.wav";

import patient_waiting from "../../assets/patient_waiting.wav";

import { Card, Button } from "semantic-ui-react";

import { store as mainStore } from "react-notifications-component";
import { Message } from "semantic-ui-react";

import { store_modal_view } from "../../actions/mqttAction";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import store from "../../index";

import { OPEN_STORE_MODAL } from "../../actions/types";

class NotificationComponent extends React.Component {
  // constructor(props) {
  //   super(props);
  //   this.state = {

  //   };
  //   this.startCall = this.startCall.bind(this);

  // }

  approvedNotification(prescID, pharmaName) {
    var sound = new Audio(approved_sound);
    sound.play();

    const mBody = (
      <Message color="green">
        <div>
          <h6 className="notificationHeading">
            <strong>{pharmaName}</strong> has approved your prescription{" "}
            <strong>{prescID}</strong>
          </h6>
        </div>
      </Message>
    );
    this.notify(mBody);
  }

  messageNotification(senderName) {
    var sound = new Audio(message_sound);
    sound.play();

    const mBody = (
      <Message color="black">
        <div>
          <h6 className="notificationHeading">
            you have a <strong>New Message</strong> from{" "}
            <strong>{senderName}</strong>
          </h6>
        </div>
      </Message>
    );
    this.notifyMessage(mBody);
  }

  rejectedNotification(prescID, pharmaName) {
    var sound = new Audio(rejected_sound);
    sound.play();

    const mBody = (
      <Message color="red">
        <div>
          <h6 className="notificationHeading">
            <strong>{pharmaName}</strong> has rejected your prescription{" "}
            <strong>{prescID}</strong>
          </h6>
        </div>
      </Message>
    );
    this.notify(mBody);
  }

  reviewNotification(prescID) {
    var sound = new Audio(pending_sound);
    sound.play();

    const mBody = (
      <Message color="blue">
        <div>
          <h6 className="notificationHeading">
            Prescription : <strong>{prescID}</strong> is ready to be{" "}
            <strong>Reviewed</strong>..!!
          </h6>
        </div>
      </Message>
    );
    this.notify(mBody);
  }

  workingNotification(prescID, pharmaName) {
    var sound = new Audio(editing_sound);
    sound.play();

    const mBody = (
      <Message color="brown">
        <div>
          <h6 className="notificationHeading">
            <strong>{pharmaName}</strong> has started working on your
            prescription <strong>{prescID}</strong>
          </h6>
        </div>
      </Message>
    );
    this.notify(mBody);
  }

  patientWaiting(prescID, patientName) {
    var sound = new Audio(patient_waiting);
    sound.play();
    this.showNotification("*PatientWaiting* Please Review " + prescID + ' \n' + new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString())

    const mBody = (
      <Message color="teal">
        <div>
          <h6 className="notificationHeading">
            Prescription : <strong>{prescID}</strong> is ready to be{" "}
            <strong>Reviewed</strong>..!!
            <br></br>

            <strong>{patientName}</strong> is waiting for the prescription{" "}
            <strong>{prescID}</strong>
          </h6>
        </div>
      </Message>
    );
    this.notifyPatientWaiting(mBody);
  }

  counsellingCallNotification(rxNumber, patientName, no_of_rxs, branchName, destinationName) {
    var sound = new Audio(waiting_sound);
    sound.play();
    this.showNotification("Counselling Call From " + branchName + ' \n' + new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString())

    const rxNumbersDiv = rxNumber ? <h3 className="counsil-rxNumber">
      Prescription Number(s) :{" "}
      <strong className="counsil-rxn">{rxNumber}</strong>
    </h3> : <h3>Incoming Counselling Request ...</h3>

    const mBody = (
      <Card color="teal" style={{ width: "350px", height: "280px" }}>
        <div className="text-center">
          <h3>Counselling Call ...</h3>
        </div>

        <div>
          <h1 className="notificationHeading counsil-patient text-center">
            <strong>{patientName}</strong>
          </h1>
          <hr></hr>
          <div className="counsil-notif text-center">
            {rxNumbersDiv}
            <h3 className="counsil-rxNumber">
              Call From :
              <strong className="counsil-brn"> {branchName}</strong>
            </h3>
          </div>
        </div>
        <div className="counsil-buttons">
          <Button
            circular
            className="float-left text-center"
            style={{ marginLeft: "20%", color: "grey" }}
          >
            <i class="far fa-bell-slash  fa-2x"></i>
          </Button>

          <Button
            circular
            className="float-right text-center"
            style={{ marginRight: "20%", color: "#0e566c" }}
            onClick={() => this.startCall(rxNumber, branchName, destinationName)}
          >
            <i class="fas fa-video float-right fa-2x"></i>
          </Button>
        </div>
      </Card>
    );
    this.notifycounsellingCall(mBody);
  }

  startCall(rxNumber, branchName, destinationName) {
    console.log("==============Inside Start Call==============", branchName + " ...", rxNumber)
    let payload

    if (!rxNumber) {
      console.log('isManualDial :>> ', true);
      console.log('destinationName :>> ', destinationName);
      payload = { show_store: true, undefined, branchName, destinationName }
    }
    else {
      payload = { show_store: true, rxNumber, branchName, destinationName }
    }
    store.dispatch({
      type: OPEN_STORE_MODAL,
      payload
    });
    // store_modal_view(true);
  }

  notifyPatientWaiting(result) {
    mainStore.addNotification({
      content: result,

      type: "success", // 'default', 'success', 'info', 'warning'
      container: "bottom-right", // where to position the notifications
      animationIn: ["animated", "fadeIn"], // animate.css classes that's applied
      animationOut: ["animated", "fadeOut"], // animate.css classes that's applied
      dismiss: {
        duration: 0
      }
    });
  }

  notifycounsellingCall(result) {
    mainStore.addNotification({
      content: result,
      type: "success", // 'default', 'success', 'info', 'warning'
      container: "bottom-right", // where to position the notifications
      animationIn: ["animated", "fadeIn"], // animate.css classes that's applied
      animationOut: ["animated", "fadeOut"], // animate.css classes that's applied
      dismiss: {
        duration: 30000
      }
    });
  }

  notify(result) {
    mainStore.addNotification({
      content: result,

      type: "success", // 'default', 'success', 'info', 'warning'
      container: "bottom-right", // where to position the notifications
      animationIn: ["animated", "fadeIn"], // animate.css classes that's applied
      animationOut: ["animated", "fadeOut"], // animate.css classes that's applied
      dismiss: {
        duration: 5000
      }
    });
  }

  notifyMessage(result) {
    mainStore.addNotification({
      content: result,

      type: "success", // 'default', 'success', 'info', 'warning'
      container: "bottom-right", // where to position the notifications
      animationIn: ["animated", "fadeIn"], // animate.css classes that's applied
      animationOut: ["animated", "fadeOut"], // animate.css classes that's applied
      dismiss: {
        duration: 5000
      }
    });
  }

  showNotification(mBody) {
    var options = {
      title: ":: TeleRx :: ",
      body: mBody,
      dir: 'ltr',
      requireInteraction: true
    };
    new Notification(':: TeleRx ::\n ', options);
  }

}

NotificationComponent.propTypes = {
  store_modal_view: PropTypes.func.isRequired
};
// const mapStateToProps = state => ({
//   mqtt: state.mqtt,
//   auth: state.auth
// });
export default NotificationComponent;
